/**
 * Record actions your users perform
 * @param {object} event - Type of google event "GA4Event".
 * @param {string} eventName - The name of the event you’re tracking.
 * @param {object} params - A dictionary of properties for the event.
 */
function trackEvent(eventDefinition) {
  return (action, previousState, nextState) => {
    const event = eventDefinition(action, previousState, nextState);
    return {
      event: event.event,
      eventName: event.eventName,
      params: event.params
    };
  };
}

/* Calling reset resets the id, including anonymousId, and clears traits for the currently identified user and group. */
function reset() {
  return () => ({
    hitType: 'reset'
  });
}

export { trackEvent, reset };
